export function createAction(payload) {
  return {
    payload
  };
}
export const initialState = {
  isSoftInputShown: false,
  softInputHeight: 0
};
export function reducer(state, action) {
  if (action.payload === 0) {
    return { ...state,
      isSoftInputShown: false,
      softInputHeight: action.payload
    };
  }

  if (!state.isSoftInputShown) {
    return { ...state,
      isSoftInputShown: true,
      softInputHeight: action.payload
    };
  }

  return { ...state,
    softInputHeight: action.payload
  };
}
//# sourceMappingURL=stateReducer.js.map